import { __require as r } from "../node_modules/@mui/system/colorManipulator.js";
var a = /* @__PURE__ */ r();
export {
  a as c
};
